var React = require('react');

function Business (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","opacity":"1"},[React.createElement("path",{"fill":"currentColor","d":"M16 9.333V4H2.667v24h26.666V9.333H16zm-8 16H5.333v-2.666H8v2.666zM8 20H5.333v-2.667H8V20zm0-5.333H5.333V12H8v2.667zm0-5.334H5.333V6.667H8v2.666zm5.333 16h-2.666v-2.666h2.666v2.666zm0-5.333h-2.666v-2.667h2.666V20zm0-5.333h-2.666V12h2.666v2.667zm0-5.334h-2.666V6.667h2.666v2.666zm13.334 16H16v-2.666h2.667V20H16v-2.667h2.667v-2.666H16V12h10.667v13.333zM24 14.667h-2.667v2.666H24v-2.666zM24 20h-2.667v2.667H24V20z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H32V32H0z","key":1})]));
}

Business.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Business;

Business.default = Business;
